
<template>
    <div
        v-if="showTalkList"
        class="md user-talk"
    >
        <div class="heading">
            <div class="caption">
                <div class="name">
                    <div class="box">{{ $t('site.func.talk') }}</div>
                </div>
            </div>
            <ul class="func">
                <li class="minisize"><a @click="talkMiniSize(useChannel)"></a></li>
            </ul>
        </div>
        <div class="content">
            <ul class="func">
                <li
                    v-for="channel in talkChannelsSortByTime"
                    :class="[channel.unread > 0? 'not-yet': '']"
                    :key="channel.cid"
                >
                    <a
                        class="div"
                        @click="talkActiveAndClose(channel)"
                    >
                        <div
                            class="image"
                            :style="'background-image: url('+ $talkTool.getAvatar(channel) +')'"
                        ></div>
                        <div class="essay">
                            <div class="caption">{{ channel.name }}</div>
                            <div class="p">
                                <div class="text">{{ $talkTool.getLastMsg(channel) }}</div>
                                <div class="time">{{ getTime(channel.lasttime) }}</div>
                            </div>
                        </div>
                    </a>
                </li>
            </ul>
        </div>
        <div class="footer"></div>
    </div>
</template>

<script>
    import cpLabel from '@/components/cpLabel'

    import { mapState, mapMutations } from 'vuex'

    export default {
        components: {
            cpLabel,
        },
        data: function(){
            let $today = new Date(),
                _year = $today.getFullYear(),
                _month = this.$okaTool.doubleCount($today.getMonth() + 1),
                _date = this.$okaTool.doubleCount($today.getDate());

            return {
                today: {
                    year: _year,
                    month: _month,
                    date: _date,
                },
            }
        },
        computed: {
            ...mapState([
                'talk',
                'showTalkList',
                'talkChannels',
                'talkViewTime',
            ]),
            talkChannelsSortByTime: function(){
                return this.talkChannels.sort((a, b) => { return a.lasttime > b.lasttime? -1: 1 });
            },
        },
        methods: {
            ...mapMutations([
                'changeState',
                'globalClickFuncQueuePush',
                'globalClickFuncQueueRun',
                'globalClickFuncQueueClear',
                'talkActive',
            ]),
            getTime: function(lasttime){
                let $time = new Date(lasttime),
                    _year = $time.getFullYear(),
                    _month = this.$okaTool.doubleCount($time.getMonth() + 1),
                    _date = this.$okaTool.doubleCount($time.getDate()),
                    _hours = this.$okaTool.doubleCount($time.getHours()),
                    _minutes = this.$okaTool.doubleCount($time.getMinutes());

                let $today = this.today;

                if( $today.year === _year && $today.month === _month && $today.date === _date ) {
                    return _hours +':'+ _minutes;
                }else {
                    return _month +'/'+ _date;
                }
            },
            talkMiniSize: function(){

                this.changeState({
                    showTalkList: false,
                });
            },
            talkActiveAndClose: function(channel){
                this.talkActive(channel);

                this.talkMiniSize();
            },
        },
    }
</script>

<style scoped lang="scss">

    .md.user-talk {
        $pic_z: 36px;
        $ft_z: 32px;

        z-index: 4;
        position: fixed;
        display: flex;
        flex-direction: column;
        height: calc(100vh - 200px);
        max-height: 600px;
        width: 360px;
        right: 60px;
        bottom: $interval-m;
        background-color: $white;
        border-radius: $border-radius;
        box-shadow: $box-shadow;

        @include media('phone') {
            width: 260px;
            max-height: none;
            height: calc(100vh - 150px);
        }

        .heading {
            flex-shrink: 0;
            display: flex;
            background-color: $major-color;
            border-radius: $border-radius $border-radius 0 0;
            padding: $interval-s;

            .caption {
                display: flex;
                flex: 1;
                width: 0;

                .name {
                    padding: 0 $interval-s;
                    flex-grow: 1;
                    font-size: $font-size-l;
                    line-height: $pic_z;
                    color: $white;

                    .box {
                        @extend %ellipsis;
                    }
                }
            }

            /*ul*/.func {
                @extend %reset;
                display: flex;
                padding-left: $interval-m;
                align-items: center;

                li {

                    + li {
                        padding-left: $interval-s;
                    }

                    &.minisize {
                        
                        a {
                            
                            &::before {
                                content: '\e15b';
                            }
                        }
                    }
                }

                a {
                    transition: $transition;
                    display: block;
                    height: $ft_z;
                    width: $ft_z;
                    text-align: center;
                    cursor: pointer;
                    border-radius: $border-radius;
                    background-color: $minor-color;
                    color: $deep;

                    &:hover {
                        opacity: $opacity-m
                    }

                    &::before {
                        display: block;
                        @extend %font-pseudo;
                        line-height: $ft_z;
                    }
                }
            }
        }

        .content {
            flex-grow: 1;
            flex-shrink: 1;
            position: relative;
            overflow-y: auto;
            overflow-x: hidden;
            overscroll-behavior: contain;

            ul.func {
                @extend %reset;
                // display: block;
                // top: 100%;
                // right: 0;
                // margin-top: 0;
                // padding: $interval-m;
                // max-height: calc(100vh - 80px);
                // overflow: auto;

                // @include media('phone') {
                //     position: fixed;
                //     top: 50px;
                //     left: 0;
                //     right: 0;
                //     bottom: 0;
                //     max-height: none;
                // }

                $type: map-get($colors, 'danger');
                $text: map-get($type, 'text');

                li {

                    + li {
                        margin-top: $interval-s;
                    }

                    &.not-yet {
                        
                        /*a*/.div {

                            .image {
                                box-shadow: 0 0 0 2px $text inset;
                            }

                            &::before {
                                content: $content;
                            }
                        }
                    }

                    a {
                        cursor: pointer;
                    }
                }

                $size: 50px;
                
                /*a*/.div {
                    display: block;
                    position: relative;
                    min-height: $size;
                    padding: $interval-s;
                    color: inherit;
                    transition: $transition;

                    &:hover {
                        background-color: $light;
                    }

                    &::before {
                        position: absolute;
                        top: 9px;
                        left: 9px;
                        width: $interval-m;
                        height: $interval-m;
                        border-radius: 50%;
                        background-color: $text;
                        z-index: 1;
                    }
                }

                .image {
                    position: absolute;
                    top: $interval-s;
                    left: $interval-s;
                    width: $size;
                    height: $size;
                    border-radius: 50%;
                    background-repeat: no-repeat;
                    background-position: center;
                    background-size: cover;
                    background-image: image-url('product.jpg');
                }

                .essay {
                    position: relative;
                    padding-left: $size + $interval-s * 2;
                    transition: $transition;
                    flex: 1;

                    .caption {
                    }

                    .p {
                        display: flex;
                        color: $gray;

                        .text {
                            flex: 1;
                            @extend %ellipsis;
                        }

                        .time {

                        }
                    }
                }
            }
        }

        .footer {
            flex-shrink: 0;
            height: $interval-s;
            border-top: $border;
            background-color: $light;
            display: flex;
            border-radius: 0 0 $border-radius $border-radius;
        }
    }
</style>
